import { useMemo } from "react"
import { Avatar, AvatarProps, Tooltip, TooltipProps } from '@mui/material'

import { useGetUserIcon, UserResult } from "interface/user"

type UserAvatarProps = {
  user?: UserResult
  userId?: number
  userName?: string
  toolTip?: TooltipProps['title']
} & AvatarProps
export const UserAvatar = ({
  user,
  userId,
  userName,
  toolTip,
  ...others
}: UserAvatarProps) => {
  const userIconState = useGetUserIcon(user ? user.userId : userId)
  const userIcon = useMemo(
    () => userIconState.data ? URL.createObjectURL(userIconState.data.blob) : undefined,
    [userIconState]
  )
  return toolTip ? (
    <Tooltip title={toolTip}>
      <Avatar
        src={userIcon}
        alt={user ? user.userName : userName}
        {...others}
      />
    </Tooltip>
  ) : (
    <Avatar
      src={userIcon}
      alt={user ? user.userName : userName}
      {...others}
    />
  )
}